import { render, staticRenderFns } from "./CustodyBtns.vue?vue&type=template&id=d70491cc&"
import script from "./CustodyBtns.vue?vue&type=script&lang=js&"
export * from "./CustodyBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports